import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { Logo } from './Logo';
import { navLinks } from '../data/content';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className="fixed inset-x-0 top-0 z-50" data-id="element-40" data-mp="2wiw0uo9ywa3l">
      <div className={`w-full border-b backdrop-blur-xl transition-all duration-300 ${scrolled ? 'border-slate-200/70 bg-white/80 shadow-soft' : 'border-transparent bg-canvas/60'}`} data-id="element-41" data-mp="31d9xeu0d8n9u">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 lg:h-[72px] lg:px-10" data-id="element-42" data-mp="3b8bm5oqqbnbw">
          <a href="#inicio" aria-label="Almaria, ir al inicio" data-id="element-43" data-mp="2wkul8qn73d4p">
            <Logo data-id="element-44" data-mp="2wm5tb2nob71m" />
          </a>

          <nav aria-label="Navegación principal" className="hidden lg:block" data-id="element-45" data-mp="2rlrl9km2nx3l">
            <ul className="flex items-center gap-1" data-id="element-46" data-mp="2rnuf6fqciadl">
              {navLinks.map(link => <li key={link.label} data-id="element-47" data-mp="2mordn59kqmad">
                  <a href={link.href} className="rounded-full px-3.5 py-2 text-sm font-medium text-ink-soft transition-colors hover:bg-slate-100/80 hover:text-ink" data-id="element-48" data-mp="2ho3jwbtynrcg">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div className="flex items-center gap-2" data-id="element-49" data-mp="35jpw4g16pbec">
            <a href="#contacto" className="hidden rounded-full bg-ink px-5 py-2.5 text-sm font-medium text-white shadow-soft transition-all duration-200 hover:-translate-y-0.5 hover:bg-[#1b2537] hover:shadow-lift lg:inline-flex" data-id="element-50" data-mp="30mzcjiq67xo6">
              Hablemos
            </a>
            <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? 'Cerrar menú' : 'Abrir menú'} className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-slate-200 bg-white text-ink transition-colors hover:bg-slate-50 lg:hidden" data-id="element-51" data-mp="1rdbdcse438ta">
              {open ? <XIcon className="h-5 w-5" data-id="element-52" data-mp="18mtvxjyqbzn8" /> : <MenuIcon className="h-5 w-5" data-id="element-53" data-mp="18lij6unb3hjz" />}
            </button>
          </div>
        </div>

        <AnimatePresence data-id="element-54" data-mp="1cq8eoie1yu4d">
          {open && <motion.nav aria-label="Navegación móvil" initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} className="overflow-hidden border-t border-slate-200/70 bg-white/95 lg:hidden" data-id="element-55" data-mp="yp5nxsc44vn4">
              <ul className="mx-auto max-w-7xl space-y-1 px-6 py-4" data-id="element-56" data-mp="meo6p7hxdjn0">
                {navLinks.map(link => <li key={link.label} data-id="element-57" data-mp="hg3gm0we0gca">
                    <a href={link.href} onClick={() => setOpen(false)} className="block rounded-xl px-3 py-3 text-base font-medium text-ink-soft transition-colors hover:bg-slate-50 hover:text-ink" data-id="element-58" data-mp="hh4ro5del2u0">
                      {link.label}
                    </a>
                  </li>)}
                <li className="pt-2" data-id="element-59" data-mp="1051ftd6jz4dx">
                  <a href="#contacto" onClick={() => setOpen(false)} className="block rounded-xl bg-ink px-4 py-3 text-center text-base font-medium text-white" data-id="element-60" data-mp="1085oonuyqoax">
                    Hablemos
                  </a>
                </li>
              </ul>
            </motion.nav>}
        </AnimatePresence>
      </div>
    </header>;
}